






















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TeacherService } from '../../biz/remote/TeacherService';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import PageNation from '../../components/organisms/PageNation.vue';
import SortTh from '../../components/atoms/SortTh.vue';
import { TableColumn } from '../../components/organisms/CommonTable.vue';
import TeachersRow from './TeachersRow.vue';
import TeacherInfoMaintenance from './TeacherInfoMaintenance.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import { getCircleOBuilding } from '../../../src_server/entity/master/buildingData';
import { NotifyMail } from './NotifyMail';
import TeacherInteviewDialog from './TeacherInteviewDialog.vue';
import ReportLogDialog from './ReportLogDialog.vue';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import LessonLogDialog from './LessonLogDialog.vue';
import { routeHelper } from '../../utils/routeHelper';
import { URIs } from '../../../src_server/common/URIs';
import { Session } from '../../utils/Session';
import { ErrorHandler } from '../../utils/ErrorHandler';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';
import { AuthService } from '../../biz/remote/AuthService';
import NotifyMessageDialog from '../notify_dialog/NotifyMessageDialog.vue';
@Component({
  components: {
    CommonDialog,
    PageNation,
    SortTh,
    TeachersRow,
    TeacherInfoMaintenance,
    TeacherInteviewDialog,
    ReportLogDialog,
    SimpleSelect,
    LessonLogDialog,
    NotifyMessageDialog,
  },
})
export default class TeachersListPage extends Vue {
  public cols: TableColumn[] = [
    { label: 'No', type: 'seq' },
    {
      label: '',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `<img class="img-round rounded-circle" width="60px" height="60px" onerror="this.src='/assets/logos/default.png'" src="${row.teacher.img_path}" />`;
      },
    },
    {
      label: '編集',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem  small-xs': true,
      },
      onclick: this.detail,
    },
    {
      label: '面接資料',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-705rem  small-xs': true,
      },
      onclick: this.interviewDocumnet,
    },
    {
      label: '日報履歴',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-705rem  small-xs': true,
      },
      onclick: this.reportLog,
    },
    {
      label: 'レッスン履歴',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem  small-xs': true,
      },
      onclick: this.lessonLog,
    },
    {
      label: '申込日',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `${dayjs(row.teacher.application_dt).format(DT_FORMAT_JA)}`;
      },
    },

    { label: '名前', name: 'teacher.nickname' },
    { label: '累積生徒<br>担当数', name: 'total_student_count' },
    { label: '累積授業<br>数', name: 'total_lesson_count' },
    {
      label: 'LINEメッセージ送信',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs': true,
      },
      onclick: this.messageLog,
    },

    {
      label: '採用メール再送',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-705rem  small-xs': true,
      },
      onclick: this.remail,
    },
    {
      label: 'メンテナンスログイン',
      btnClass: {
        btn: true,
        'pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem  small-xs': true,
      },
      onclick: this.forceLogin,
    },
  ];

  private selectedRow: TeacherInfoInputDTO = new TeacherInfoInputDTO();
  private teacherRows: TeacherInfoInputDTO[] = [];
  private selectedTeacher = {};

  private loading = false;
  private viewCount = 10;

  private filter = '';

  @Watch('filter')
  async loadData() {
    this.loading = true;
    const biz = new TeacherService();
    const response = await biz.getTeachers(getCircleOBuilding());
    this.teacherRows = response.data
      .filter((r) => {
        this.loading = false;
        if (!this.filter) return true;
        return r.teacher.full_name?.match(this.filter);
      })
      .sort((a, b) => {
        this.loading = false;
        if (!a.teacher.application_dt || !b.teacher.application_dt || a.teacher.application_dt === b.teacher.application_dt) {
          return 0;
        }
        if (a.teacher.application_dt > b.teacher.application_dt) {
          return -1;
        } else {
          return 1;
        }
      });
  }

  detail(row: any) {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.show(row);
  }

  async remail(row: any) {
    const biz = new TeacherService();
    await MessageDialog.alertModal(`採用通知メールを起動します。パスワードは初期パスワードにリセットされます。`);

    const name = `${row.teacher.full_name}`;
    const user_id = row.teacher.user_id;
    const email = row.teacher.email;
    const res = await biz.getSuccessMailMessage(user_id, email, name, getCircleOBuilding());
    if (res.hasError) {
      await MessageDialog.alert(res.errorDescription);
      return;
    }
    const mail = res.data;
    const notify = new NotifyMail();
    notify.openMailWindow(email, mail.subject, mail.body);
  }

  cancel() {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.hide();
  }

  mounted() {
    this.loadData().then();
  }

  reportLog(row: any) {
    const dialog = this.$refs['teacher_report_log_dialog'] as ReportLogDialog;
    dialog.show(row.teacher);
  }

  lessonLog(row: any) {
    const dialog = this.$refs['LessonLogDialog'] as LessonLogDialog;
    dialog.show(row.teacher);
  }

  /**
   * 面接資料のイベントハンドラ
   */
  interviewDocumnet(row: any) {
    console.log(row);
    const dialog = this.$refs['teacher_inteview_dialog'] as TeacherInteviewDialog;
    dialog.show(row.teacher);
  }

  deleted(user_id: string) {
    console.log('user_id', user_id);
    const index = this.teacherRows.findIndex((t) => {
      return t.userAuth.user_id === user_id;
    });
    this.teacherRows.splice(index, 1);
  }

  async messageLog(row: any) {
    // routeHelper(this, 'AdminMessagePage', {
    //   user_id: row.teacher.user_id,
    //   user_type: 'tea',
    // });
    const dialog: NotifyMessageDialog = this.$refs['NotifyMessageDialog'] as NotifyMessageDialog;
    dialog.show(row.teacher.user_id);
  }
  async csvDl() {
    const url = `${URIs.ALL_TEACHER_CSV_DOWNLOAD.path}?building_id=${Session.getSessionBuildingId()}&token=${Session.getJwtToken()}`;
    location.href = url;
  }

  async forceLogin(row: any) {
    const pass = await MessageDialog.prompt('メンテナンスログインします。パスコードを入力してください');
    if (pass === 'co01') {
      MessageDialog.info(
        row.userAuth.user_name + 'にメンテナンスログインします。操作は実際にユーザデータに反映されるため、注意してください。操作終了後は一旦ログアウトしてから管理者ページに戻ってください'
      );
      const user_id = row.userAuth.user_id;
      const biz = new AuthService();
      const result = await biz.forceLogin(user_id, 'tea', 'co01');

      if (!result || result.hasError) {
        ErrorHandler.atResponseError(result);
        return;
      }
      const dto = result.data;
      Session.set<UserAuthDTO>('USER', dto);

      const redirectPath = `/teacher-dashboard-page?building=co01`;
      this.$router.push(redirectPath);
    }
  }
}
